{ "closeAria": "Close", "historyAria": "Appeal history", "supportTitle": "Support" }
